import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAiMetadataStore } from '@/modules/viewer/store/useAiMetadataStore';
import { useSmartActionsStore } from '@/modules/viewer/store/useSmartActionsStore';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useVideoAi } from '@/modules/viewer/composables/useVideoAi';

export const useSmartActionsNoVoice = () => {
  const { isProcessing: isAiMetadataProcessing } = storeToRefs(useAiMetadataStore());
  const { isProcessing: isSmartActionsProcessing } = storeToRefs(useSmartActionsStore());
  const { isTranscriptionFinished, isTranscriptionProcessing, isTranscriptionMissingContent } = storeToRefs(useTranscriptionStore());
  const { hasAudioStream, isEditProcessing } = storeToRefs(useViewerItemStore());
  const { hasTranscriptionEntitlement } = useVideoAi();

  const isProcessing = computed(() => {
    return isAiMetadataProcessing.value || isSmartActionsProcessing.value || isEditProcessing.value || isTranscriptionProcessing.value;
  });

  const hasTerminalNoVoice = computed(() => {
    return (
      hasTranscriptionEntitlement.value &&
      !isProcessing.value &&
      (hasAudioStream.value === false || (isTranscriptionFinished.value && isTranscriptionMissingContent.value))
    );
  });

  return { hasTerminalNoVoice };
};
